module.exports = __webpack_public_path__ + "static/use-case-6-content-2-a-8f8ea6e982be370a4678d20e8a471dc4.png";